'use strict';

const React = require( 'react' );
const ReviewItems = require( './reviewItems.jsx' );
const getAirportInfo = require( '../getAirportInfo' );
const propTypes = require('prop-types');
const Helpers = require( '../../../../../_plugins/lib/helpers' );
const { object, string } = propTypes;
const createReactClass = require('create-react-class');

const ReviewsResults = createReactClass({
  mixins: [Helpers],

  propTypes: {
    id: string.isRequired,
    pageData: object.isRequired
  },

  shouldComponentUpdate( ) {
    return false;
  },

  getReviews( ) {
    const { id, pageData: { pageName, productClass } } = this.props;
    const location = getAirportInfo( pageName );
    let code = '';
    if ( !location || !location.code ) {
      if ( pageName.indexOf( 'airport-parking' ) > -1 ) {
        code = 'airportParkingReviews';
      }
      if ( pageName.indexOf( 'airport-hotels' ) > -1 ) {
        code = 'airportHotelsReviews';
      }
    } else {
      code = location.code;
      if ( productClass.toUpperCase( ) === 'CP' ) {
        code = 'parking/' + code;
      } else {
        code = 'hotels/' + code;
      }
    }

    try {
      return require( '../../../../../config/exports/reviews/' + code + '.json' );
    } catch ( e ) {
      // Do nothing with the error
      if (typeof window === 'undefined') return null
      const element = this.$( '#' + id );
      if ( !element ) return null;
      return element.innerHTML;
    }
  },

  render( ) {
    const { id } = this.props;
    const reviews = this.getReviews( );
    if ( !( reviews && reviews.reviews )) return ( <span id={ id } /> );

    return (
      <span id={ id } className="reviews-results">
        <h2>Customer Reviews</h2>
        <ReviewItems reviews={ reviews.reviews } />
      </span>
    );
  }
});

module.exports = ReviewsResults;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviews-results-bootstrap.jsx